import React, { useEffect, useState } from "react";
import noavatar from "../../../assets/img/noavatar.png";
import { TfiCar } from "react-icons/tfi";
import NoProduct from "../../../components/user/Order/noProduct";
import ModalConfirm from "../../admin/ModalConfirm";
import Pagination from "../../pagination";
import { GrEdit } from "react-icons/gr";
import useLocation from "../Location/useLocation";
import { Button, Modal, ModalBody, ModalHeader } from "reactstrap";
import Select from "react-select";
import { getData, putData } from "../../../api/method";
import { toast } from "react-toastify";

function Waitting({
  args,
  data,
  getOrderById2,
  openShip2,
  toggleShip2,
  closeBtnShip2,
  handleSubmitCancel,
}) {
  const dataFiter = data.filter((item) => item.status === 0);

  const [currentPage, setCurrentPage] = useState(1);
  const [dataPerPage, setDataPerPage] = useState(2);

  const indexOfLastData = currentPage * dataPerPage;
  const indexOfFirstData = indexOfLastData - dataPerPage;
  const currentData = dataFiter.slice(indexOfFirstData, indexOfLastData);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const [openEdit, setOpenEdit] = useState(false);

  const toggleEdit = () => setOpenEdit(!openEdit);

  const closeBtnEdit = (
    <button className="close" onClick={toggleEdit}>
      &times;
    </button>
  );

  const { state, onCitySelect, onDistrictSelect, onWardSelect, onSubmit } =
    useLocation(false);

  const {
    cityOptions,
    districtOptions,
    wardOptions,
    selectedCity,
    selectedDistrict,
    selectedWard,
  } = state;

  const [error, setError] = useState({});
  const [address, setAddress] = useState("");
  const [ward, setWard] = useState("");
  const [district, setDistrict] = useState("");
  const [city, setCity] = useState("");

  const validation = (e) => {
    const msg = {};

    if (address === "") {
      msg.address = "Address is requied!";
    }

    setError(msg);
    if (Object.keys(msg).length > 0) return false;
    return true;
  };

  const handleKeyUp = () => {
    validation();
  };

  const [dataEdit, setDataEdit] = useState([]);

  const getOrderByEdit = async (id) => {
    try {
      const result = await getData(`/api/Order/${id}`);
      setDataEdit(result.data);
      setAddress(result.data.address);
      setWard(result.data.ward);
      setDistrict(result.data.district);
      setCity(result.data.city);
      setOpenEdit(true);
    } catch (error) {
      console.log(error);
    }
  };

  const handleSubmitEdit = async (id) => {
    const editData = new FormData();
    const isValid = validation();

    if (isValid) {
      editData.append("id", id);
      editData.append("status", 0);
      editData.append("address", address);
      editData.append("ward", selectedWard.label);
      editData.append("district", selectedDistrict.label);
      editData.append("city", selectedCity.label);
      editData.append("userId", dataEdit.userId);

      try {
        const res = await putData(`/api/Order/${id}`, editData);
        if (res.status === 200) {
          toast.success("Success!");
          setOpenEdit(false);
        }
      } catch (err) {
        console.log(err);
        toast.error("Fail!");
      }
    }
  };

  return (
    <>
      {currentData?.length > 0 ? (
        <div>
          {currentData
            ?.sort((a, b) => new Date(b.date) - new Date(a.date))
            .map((item) => (
              <div className="tab_content py-4 mb-4" key={item.id}>
                <div className="px-4">
                  <div className="d-flex justify-content-between pb-3">
                    <p className="fs-6 tab_date">
                      Ngày đặt: {item.date.slice(0, 10)}
                    </p>
                    <p className="tab_transport  d-flex align-items-center">
                      <TfiCar className="me-2 t-primary fs-5" />
                      <span className="t-primary fs-24">
                        {item.status === 0 ? (
                          "Waitting"
                        ) : (
                          <>
                            {item.status === 1 ? (
                              "Delivery"
                            ) : (
                              <>
                                {item.status === 2 ? (
                                  "Received"
                                ) : (
                                  <>{item.status === 3 ? "Cancelled" : ""}</>
                                )}
                              </>
                            )}
                          </>
                        )}
                      </span>
                    </p>
                  </div>

                  {item.orderDetails.map((p, i) => (
                    <div
                      className="d-flex align-items-center justify-content-between border-top border-bottom py-3 px-4"
                      key={i}
                    >
                      <div className="tab_img w-12">
                        <img
                          src={
                            `${
                              process.env.REACT_APP_URL_IMAGE + p.product.image
                            }` || noavatar
                          }
                          alt="product"
                          width={100}
                          height={100}
                        />
                      </div>

                      <div className="tab_product w-100 d-flex flex-column px-4">
                        <p className="product_name fw-600 fs-24">
                          {p.product.name}
                        </p>
                        <p className="product_category py-1">
                          {p.product.category.name}
                        </p>
                        <p className="product_quantity">x{p.quantity}</p>
                      </div>
                      <div className="product_price w-12 text-end fs-20">
                        {(
                          (p.product.price * (100 - p.product.discount)) /
                          100
                        ).toLocaleString("vi")}
                        &#273;
                      </div>
                    </div>
                  ))}

                  <div className="d-flex align-items-center justify-content-between">
                    <div className="d-flex justify-content-start align-items-center">
                      <p className="t-capitalize">
                        {item.address}, {item.ward}, {item.district},{" "}
                        {item.city}
                      </p>
                      <div
                        className="ms-3 fs-20 cursor_pointer"
                        onClick={() => getOrderByEdit(item.id)}
                      >
                        <GrEdit className="fs-4" />
                      </div>
                    </div>

                    <div className="product_total d-flex align-items-center justify-content-end pt-3 fs-24">
                      <div
                        className="btn_order me-3"
                        onClick={() => getOrderById2(item.id)}
                      >
                        Cancelled
                      </div>
                      <p>
                        Total:{" "}
                        <span className="product_price t-primary fs-20 fw-bold">
                          {(item.totalPrice * 1).toLocaleString("vi")}&#273;
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ))}

          <ModalConfirm
            title="Confirm"
            text="Are you sure you want to cancel the order?"
            toggle={toggleShip2}
            close={closeBtnShip2}
            isOpen={openShip2}
            onClick={handleSubmitCancel}
          />
        </div>
      ) : (
        <NoProduct />
      )}

      <Pagination
        paginate={paginate}
        postsPerPage={dataPerPage}
        totalPosts={dataFiter.length}
      />

      <Modal isOpen={openEdit} toggle={toggleEdit} {...args}>
        <ModalHeader toggle={toggleEdit} close={closeBtnEdit}>
          <span className="t-primary fs-4 fw-bold">Edit</span>
        </ModalHeader>
        <ModalBody className="px-4">
          <label className="mb-2">Address</label>
          <div className="mb-2">
            <input
              className="fs-6 border_input w-100 t-capitalize"
              placeholder="House number"
              type="text"
              name="address"
              onChange={(e) => setAddress(e.target.value)}
              onKeyUp={handleKeyUp}
              defaultValue={dataEdit.address}
            />
          </div>

          <div className="d-flex mb-2">
            <Select
              name="cityId"
              key={`cityId_${selectedCity?.value}`}
              isDisabled={cityOptions.length === 0}
              options={cityOptions}
              onChange={(option) => onCitySelect(option)}
              placeholder="Tỉnh/Thành"
              defaultValue={selectedCity}
              className="w-100 fs-6 h-40 p-0 border_input"
              styles={bgStyles}
            />
          </div>

          <div className="d-flex mb-2">
            <Select
              name="districtId"
              key={`districtId_${selectedDistrict?.value}`}
              isDisabled={districtOptions.length === 0}
              options={districtOptions}
              onChange={(option) => onDistrictSelect(option)}
              placeholder="Quận/Huyện"
              defaultValue={selectedDistrict}
              className="w-100 fs-6 h-40 p-0 border_input"
              styles={bgStyles}
            />
          </div>

          <div className="d-flex mb-2">
            <Select
              name="wardId"
              key={`wardId_${selectedWard?.value}`}
              isDisabled={wardOptions.length === 0}
              options={wardOptions}
              placeholder="Phường/Xã"
              onChange={(option) => onWardSelect(option)}
              defaultValue={selectedWard}
              className="w-100 fs-6 h-40 p-0 border_input"
              styles={bgStyles}
            />
          </div>

          <div className="d-flex justify-content-center mt-4">
            <Button
              className="btn_add w-50"
              type="submit"
              onClick={() => handleSubmitEdit(dataEdit.id)}
            >
              Save
            </Button>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
}

export default Waitting;

const bgStyles = {
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    // console.log({ data, isDisabled, isFocused, isSelected });
    return {
      ...styles,
      backgroundColor: isFocused ? "#ddd6d6cc" : null,
    };
  },
};
